import { render, staticRenderFns } from "./VMCMobileHeaderCMS.vue?vue&type=template&id=3856db31&scoped=true"
import script from "./VMCMobileHeaderCMS.vue?vue&type=script&lang=js"
export * from "./VMCMobileHeaderCMS.vue?vue&type=script&lang=js"
import style0 from "./VMCMobileHeaderCMS.vue?vue&type=style&index=0&id=3856db31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856db31",
  null
  
)

export default component.exports